<template>
  <div>
    <el-card shadow="always">
      <edit-form
        ref="editForm"
        :disabled="disabled"
        :resFabricRecordCode="params.code"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'resourceManagement-research-detail',
  components: {
    EditForm,
  },
  data() {
    return {
      skuDisabled: false,
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
